import { useEffect } from "react";
import { useAuth } from "@clerk/clerk-react";
import { genericErrorHandler } from "./axios-base";
import { makeSetAuthOnRequest } from "./authInterceptor";
import axiosInstance from "./axios-config"; // your default export

export const AuthAxiosInitializer = () => {
  const { getToken } = useAuth();

  useEffect(() => {
    const setAuth = makeSetAuthOnRequest(getToken);
    axiosInstance.interceptors.request.use(setAuth, genericErrorHandler);
  }, [getToken]);

  return null;
};
